import React from 'react';
import PropTypes from "prop-types";
import SessionItem from "./sessionItem";
import {t} from 'translates';

const RequiredCourse = ({ product }) => (
  <div className="required-course">
    <div className="required-course__description">
      {product.reminder}
    </div>
    <SessionItem
      product={product}
    />
  </div>
);

RequiredCourse.propTypes = {
  product: PropTypes.object.isRequired,
}

export default RequiredCourse;
